require('./bootstrap');

window.Popper = require('popper.js').default;

require('bootstrap');

window.Dropzone = require('dropzone');

window.store = {
    apiUrl: null,
    viewUrl: null,
    ids: []
};

window.Vue = require('vue');

import ItemControl from './components/backend/ItemControl.vue';
import PositionControl from './components/backend/PositionControl.vue';
import MoveControl from './components/backend/MoveControl.vue';
import Tabs from './components/backend/Tabs.vue';
import Tab from './components/backend/Tab.vue';
import QaLists from './components/backend/QaLists.vue';
import ContactStatus from './components/backend/ContactStatus.vue';
// import ImgUpload from './components/backend/ImgUpload.vue';
// import FileUploader from './components/backend/FileUploader.vue';
// import FileUploader2 from './components/backend/FileUploader2.vue';
// import FileUploader3 from './components/backend/FileUploader3.vue';
// import FileUploader4 from './components/backend/FileUploader4.vue';
// import FileUploader5 from './components/backend/FileUploader5.vue';


const app = new Vue({
    el: '#wrapper',

    components: { ItemControl, PositionControl, MoveControl, Tabs, Tab, QaLists, ContactStatus,
        // ImgUpload, FileUploader, FileUploader2, FileUploader3, FileUploader4, FileUploader5
    },

    data() {
        return {
            store: window.store,
            newContactCounts: 0
        }
    },

    // mounted(){
    //     this.getNewContactCount();
    // },

    computed: {
        showItemControl() {
            return this.store.ids.length;
        }
    },
    methods: {
        checkAll() {
            let vm = this;
            if($('#checkAll').prop("checked")) {
                $('.check').each(function(){
                    vm.store.ids.push($(this).val());
                });
            }else{
                this.store.ids = [];
            }
        },

        // getNewContactCount()
        // {
        //     axios.get('contact/newContacts').then(r => {
        //         this.newContactCounts = r.data;
        //     });
        // },

        // updateContactStatus(id)
        // {
        //     // console.log('call');
        //     axios.patch(`/backend/contact/${id}`).then(r => {

        //     });
        // }
    }
});


$("#sidebarToggle").on('click', function(e) {
e.preventDefault();
$("body").toggleClass("sidebar-toggled");
$(".sidebar").toggleClass("toggled");
});

// Prevent the content wrapper from scrolling when the fixed side navigation hovered over
$('body.fixed-nav .sidebar').on('mousewheel DOMMouseScroll wheel', function(e) {
if ($(window).width() > 768) {
  var e0 = e.originalEvent,
    delta = e0.wheelDelta || -e0.detail;
  this.scrollTop += (delta < 0 ? 1 : -1) * 30;
  e.preventDefault();
}
});

// Scroll to top button appear
$(document).on('scroll', function() {
var scrollDistance = $(this).scrollTop();
if (scrollDistance > 100) {
  $('.scroll-to-top').fadeIn();
} else {
  $('.scroll-to-top').fadeOut();
}
});

// Smooth scrolling using jQuery easing
$(document).on('click', 'a.scroll-to-top', function(event) {
var $anchor = $(this);
$('html, body').stop().animate({
  scrollTop: ($($anchor.attr('href')).offset().top)
}, 1000, 'easeInOutExpo');
event.preventDefault();
});

// $(function () {

// var target = $('.sidebar .active');
// // console.log(target);
// $('body').scrollTop($(target).offset().top - 56);

// });



